import './WeatherModal.scss';
import { AgModal, AgModalCloseButton } from 'app/agriculture/components/Modal/AgModal';
import { useNavigate } from 'react-router-dom';
import { RainIcon, DashboardIcon } from 'app/agriculture/icons';
import { WeatherStationIcon } from 'app/agriculture/icons/devices/WeatherStationIcon';
import { primaryColourMain } from 'app/agriculture/material';
import { ToggleButtons } from 'app/agriculture/components/ToggleButtons/ToggleButtons';
import { WeatherDashboardContextProvider } from 'app/agriculture/routes/Devices/DeviceDetails/context/WeatherDashboardContextProvider';
import { WeatherDashboard } from './components/WeatherDashboard';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { ReactElement, useState } from 'react';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { WeatherDashboardSkeleton } from './components/WeatherDashboardSkeleton/WeatherDashboardSkeleton';

type WeatherDashboardViewMode = 'Dashboard' | 'Rainfall' | 'Comparison' | 'Wind';

export function WeatherModal() {
    const farmPath = useFarmPath();
    const navigate = useNavigate();
    //TODO: make this work with the dashboard when we do the rainfall view
    const [weatherDashboardViewMode, setWeatherDashboardViewMode] =
        useState<WeatherDashboardViewMode>('Dashboard');

    const options: { name: WeatherDashboardViewMode; icon: ReactElement; disabled?: boolean }[] = [
        { name: 'Dashboard', icon: <DashboardIcon size={16} /> },
        //TODO: undisable these when we need to use them
        {
            name: 'Rainfall',
            icon: <RainIcon size={16} />,
            disabled: true,
        },
        //TODO: leave these off until we have a design
        //{
        //    name: 'Comparison',
        //    icon: <ComparisonIcon size={16} />,
        //    disabled: true
        //},
        //{ name: 'Wind', icon: <WindIcon size={16} />, disabled: true }
    ];

    return (
        <WeatherDashboardContextProvider>
            <AgModal
                open
                className="WeatherModal"
                title={
                    <>
                        <div className="WeatherModalHeader__title">
                            <WeatherStationIcon size={18} color={primaryColourMain} /> Weather
                        </div>

                        <div className="WeatherModalHeader__selector">
                            <ToggleButtons
                                defaultSelection={weatherDashboardViewMode}
                                options={options}
                                onChange={(v) => {
                                    setWeatherDashboardViewMode(v.name);
                                }}
                            />
                        </div>
                        <AgModalCloseButton
                            onClick={() => {
                                navigate(farmPath('/'));
                            }}
                        />
                    </>
                }
            >
                <SuspenseWrapper loadingComponent={<WeatherDashboardSkeleton />}>
                    <WeatherDashboard />
                </SuspenseWrapper>
            </AgModal>
        </WeatherDashboardContextProvider>
    );
}
